import { call, options, params } from './helpers';

export const getReminders = (payload) =>
	call(`/beta/reminders${params(payload)}`);

export const createReminder = (payload) =>
	call(`/beta/reminders`, options(payload, 'POST'));

export const deleteReminder = (id) =>
	call(`/beta/reminders/${id}`, options(null, 'DELETE'));
